export default __webpack_public_path__ + "static/media/icon-link-deco.6546de24.svg";